import { Component } from '@angular/core';

@Component({
  selector: 'rodo',
  templateUrl: './rodo.component.html',
  styleUrls: ['./rodo.component.css']
})
export class RodoComponent {
  showHideLabel : string;
  rodoExpanded : boolean;

  constructor() {
    this.showHideLabel = "Rozwiń";
    this.rodoExpanded = false;
  }

  rodoClicked() {
    this.rodoExpanded = !this.rodoExpanded;
    this.showHideLabel = this.rodoExpanded ? "Ukryj szczegóły" : "Rozwiń";
  }
}
